export const CHANGE_TYPE_MARK_AS_READ = `MARK_AS_READ`;
export const CHANGE_TYPE_SENT_FEEDBACK = `SENT_FEEDBACK`;
export const CHANGE_TYPE_REMOVED = `REMOVED`;
